
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/el-temps/previsio/[slug]",
      function () {
        return require("private-next-pages/3catinfo/el-temps/previsio/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/el-temps/previsio/[slug]"])
      });
    }
  